<template>
    <div class="dark font-weight-600 d-flex">
        <span class="pointer mr-3 relative" @click="showingExportOptions = !showingExportOptions">
            <i class="ico ico-export fs-large"></i>
            <span>Export</span>

            <ul class="floating-menu bottom centered" v-if="showingExportOptions">
                <li v-for="exportOption in exportOptions" @click="exportOption.action">{{exportOption.label}}</li>
            </ul>

        </span>
        <span class="pointer" v-if="printAction" @click="printAction">
            <i class="ico ico-print fs-large"></i>
            <span>Print</span>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            exportOptions: {
                default: function(){
                    return [
                        {
                            label: 'Excel',
                            action: function(){console.log('clicked export excell')}
                        },
                        {
                            label: 'PDF',
                            action: function(){console.log('clicked export PDF')}
                        },
                    ]
                }
            },
            printAction: {
                default: null
            }
        },
        data: function() {
            return {
                showingExportOptions: false
            }
        },
        methods: {

        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables.scss';


</style>



// WEBPACK FOOTER //
// ExportV2.vue?567af0c0